import { ScrollView } from "react-native";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { useIsBookingSummaryNarrow } from "../../bookingSummaryWidth";

type Props = {
  header: React.JSX.Element | null;
  body: React.JSX.Element;
  footer: React.JSX.Element | null;
  isMultipleBookings?: boolean;
};

export const BookingSummaryLayout = ({
  body,
  header,
  footer,
  isMultipleBookings,
}: Props) => {
  const isNarrow = useIsBookingSummaryNarrow();

  return (
    <Box
      testID="booking-summary-layout"
      flex={isMultipleBookings ? undefined : 1}
    >
      <Box width="100%">{header}</Box>
      {isMultipleBookings ? (
        <Box
          style={{
            zIndex: 3,
            paddingBottom: 0,
          }}
        >
          <Box
            style={{ paddingBottom: 9 }}
            gap={isNarrow ? 2 : 0}
            marginTop={isNarrow ? 2 : 0}
          >
            {body}
          </Box>
        </Box>
      ) : (
        <ScrollView
          showsVerticalScrollIndicator={false}
          bounces={false}
          style={{ zIndex: 3 }}
          contentContainerStyle={{
            paddingBottom: 109,
          }}
        >
          <Box gap={isNarrow ? 2 : 0} marginTop={isNarrow ? 2 : 0}>
            {body}
          </Box>
        </ScrollView>
      )}
      <Box width="100%">{footer}</Box>
    </Box>
  );
};
